import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blank',
  template: '<div></div>'
})
export class BlankComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
